import { Stack } from "@mui/material";
import { WorkExperience } from "../../../__generated__/types";
import { employmentTypeLabels, firmSizeLabels } from "../../../utils";

export const StaticWorkExperience = ({
  value,
}: {
  value: WorkExperience[];
}) => {
  return (
    <div>
      {value.map((experience, index) => (
        <Stack spacing={1} className="work-experience-item" key={experience.id}>
          <h4 className="work-experience-title font-body font-size-4">
            {experience.company} - {experience.title}
          </h4>
          <Stack spacing={0}>
            <span className="font-size-3">
              {experience.startDate}
              {" - "}
              {experience.current ? "Current Job" : experience.endDate}
            </span>
          </Stack>
          <Stack spacing={1}>
            <span>
              {experience.firmSize
                ? `Firm Size: ${firmSizeLabels[experience.firmSize]}`
                : "Firm Size: Not specified"}
            </span>
            <span>
              {experience.employmentType
                ? `Employment Type: ${
                    employmentTypeLabels[experience.employmentType]
                  }`
                : "Employment Type: Not specified"}
            </span>
          </Stack>
        </Stack>
      ))}
    </div>
  );
};
